import { toLaunchParams } from '@/hooks/useLauncher';
import { LAUNCH_PARAM_PREFIX } from '@/hooks/useLauncher/util';
import type { GetRedirectUrlParams } from '../types';

export const PLUS_ANNUAL = 'PLUS_ANNUAL';
export const FAMILY_ANNUAL = 'FAMILY_ANNUAL';
export const PLUS_MONTHLY = 'PLUS_MONTHLY';
export const FAMILY_MONTHLY = 'FAMILY_MONTHLY';
export const BUSINESS_ANNUAL = 'BUSINESS_ANNUAL';
export const BUSINESS_MONTHLY = 'BUSINESS_MONTHLY';

export const getRedirectUrl = ({
  pathname,
  launch,
  launchParams,
  queryParams,
}: GetRedirectUrlParams): string => {
  const currentPath = pathname ?? window.location.pathname;
  const redirectUrl = new URL(currentPath, window.location.origin);

  if (launch) {
    redirectUrl.searchParams.set('launch', launch);
    if (launchParams) {
      Object.entries(toLaunchParams(launchParams)).forEach(([key, value]) => {
        redirectUrl.searchParams.set(key, value);
      });
    }
  }

  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      redirectUrl.searchParams.set(key, String(value));
    });
  }

  return `${redirectUrl.pathname}${redirectUrl.search}`;
};

/**
 * Where Stripe returns the user when they cancel or click back. Unlike the
 * success redirect, this keeps the current path and query so they land exactly
 * where they were, but strips the `launch` resume params so cancelling doesn't
 * immediately reopen the upgrade prompt they just dismissed.
 */
export const getCancelPath = (): string => {
  const url = new URL(window.location.href);
  url.searchParams.delete('launch');
  [...url.searchParams.keys()]
    .filter((key) => key.startsWith(LAUNCH_PARAM_PREFIX))
    .forEach((key) => url.searchParams.delete(key));

  return `${url.pathname}${url.search}`;
};
